import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

export const Route = createFileRoute("/app/c/$customerSlug/materials/$id")({
  component: () => <Outlet />,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
